import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { createApi } from "@reduxjs/toolkit/query/react";
 
const customerAPI = createApi({
    reducerPath: "CustomerAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getCustomers: builder.mutation({
            query: (customerQuery) => ({
                url: '/CustomerManagement/GetAllCustomerWithPagination',
                method: 'POST',
                body: transformRequest(customerQuery)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
         
         addCustomer: builder.mutation({
            query: (customerDetails) => ({
                url: '/CustomerManagement/AddCustomer',
                method: 'POST',
                body: transformRequest(customerDetails)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateCustomer: builder.mutation({
            query: (customerDetails) => ({
                url: '/CustomerManagement/UpdateCustomerById',
                method: 'POST',
                body: transformRequest(customerDetails)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getById: builder.query({
            query: (data) => ({
                url: encryptQueryString(`/CustomerManagement/GetCustomerById/?customerId=${data}`),
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
         
        getAllCountryList: builder.query({
            query: () => ({
                url: `/Country/GetAllCountries`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        deleteCustomer: builder.mutation({
            query: (id) => ({
                url: `/CustomerManagement/DeleteCustomer/?id=${id}`,
                method: 'DELETE',
                body: transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        
    })
})

export const {useGetCustomersMutation,useAddCustomerMutation,useUpdateCustomerMutation,useLazyGetByIdQuery,useLazyGetAllCountryListQuery,useDeleteCustomerMutation}=customerAPI;

export default customerAPI;